import React from "react";
import * as styles from "./style.module.scss";
import Typography from "@mui/material/Typography";

const NotificationText = ({ text }) => {
  return (
    <Typography
      component={"span"}
      className={styles?.notificationText}
      dangerouslySetInnerHTML={{ __html: text }}
    ></Typography>
  );
};

export default NotificationText;
